import { render } from "./Delete.vue?vue&type=template&id=54afa44b"
import script from "./Delete.vue?vue&type=script&lang=ts"
export * from "./Delete.vue?vue&type=script&lang=ts"
script.render = render

export default script